import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        flex: 1
    },
    cameraContainer: {
        alignSelf: "center",
        overflow: "hidden",
        aspectRatio: 1
    },
    camera: {
        ...StyleSheet.absoluteFillObject
    },
    cornerBottomRight: {
        borderBottomWidth: 4,
        borderRightWidth: 4,
        borderColor: "#E53935",
        position: "absolute",
        bottom: 20,
        right: 20,
        height: 40,
        width: 40
    },
    cornerBottomLeft: {
        borderBottomWidth: 4,
        borderColor: "#E53935",
        borderLeftWidth: 4,
        position: "absolute",
        bottom: 20,
        height: 40,
        width: 40,
        left: 20
    },
    cornerTopRight: {
        borderColor: "#E53935",
        borderRightWidth: 4,
        borderTopWidth: 4,
        position: "absolute",
        height: 40,
        width: 40,
        right: 20,
        top: 20
    },
    cornerTopLeft: {
        borderColor: "#E53935",
        borderLeftWidth: 4,
        borderTopWidth: 4,
        position: "absolute",
        height: 40,
        width: 40,
        left: 20,
        top: 20
    },
    instructionText: {
        textAlign: "center"
    },
    separatorContainer: {
        justifyContent: "space-between",
        alignSelf: "stretch",
        flexDirection: "row",
        alignItems: "center"
    },
    separatorLine: {
        height: 1,
        flex: 1
    },
    separatorText: {
    },
    manualEntryContainer: {
        alignSelf: "stretch"
    },
    manualEntryCode: {
    },
    contentContainer: {
        alignItems: "stretch"
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    headerTitleContainer: {
        position: "absolute",
        alignItems: "center",
        right: 0,
        left: 0
    },
    backButton: {
        alignSelf: "flex-start"
    },
    footerContainer: {
        flex: 1
    }
});
export default stylesheet;
